import callBusy from './files/call_busy.mp3';
import callConnect from './files/call_connect.mp3';
import callRinging from './files/call_ringing.mp3';
import callEnd from './files/call_end.mp3';

export type CallSound = 'end' | 'connect' | 'busy' | 'ringing';
let sounds: Record<CallSound, HTMLAudioElement>;

export function playSound(sound: CallSound) {
  if (!sounds[sound]) {
    return;
  }

  const doPlay = () => {
    if (sound !== 'ringing') {
      sounds.ringing.pause();
    }

    safePlay(sounds[sound]);
  };

  doPlay();
}

const safePlay = (mediaEl: HTMLMediaElement) => {
  mediaEl.play().catch((err) => {
    console.warn(err, mediaEl);
  });
};

export function initializeSounds() {
  if (sounds) {
    return;
  }

  const busyAudio = new Audio(callBusy);
  const connectAudio = new Audio(callConnect);
  const endAudio = new Audio(callEnd);
  const ringingAudio = new Audio(callRinging);
  ringingAudio.loop = true;

  sounds = {
    end: endAudio,
    connect: connectAudio,
    busy: busyAudio,
    ringing: ringingAudio,
  };
}
